import React, { Component, Fragment } from 'react';
import { toJS } from 'mobx';
import { View, ScrollView } from 'react-native';
import moment from 'moment';
import { observer } from 'mobx-react';

import { PADDING1, RED, BLUE, LIGHT_RED, LIGHT_BLUE, PURPLE } from '../styleConstants';

import { getLogPart } from '../../utils/combatUtils';

import { t } from '../../utils/appUtils';

import { CombatType } from '../../lib/types';

import Text from '../shared/Text';

import appStore from '../../stores/app';

type Props = {
  combat: CombatType;
};

@observer
export default class CombatLog extends Component<Props> {
  renderLine(line: any): any {
    if (typeof line === 'string') {
      return <Text>{line}</Text>;
    }

    if (line.time) {
      return <Text bold>{`[${moment(line.time).format('hh:mm')}]`}</Text>;
    }

    if (line.warriorOne) {
      return (
        <Text bold style={{ color: BLUE }}>
          {line.warriorOne}
        </Text>
      );
    }

    if (line.warriorTwo) {
      return (
        <Text bold style={{ color: RED }}>
          {line.warriorTwo}
        </Text>
      );
    }

    if (line.thing) {
      return (
        <Text bold style={{ color: PURPLE }}>
          {line.thing}
        </Text>
      );
    }

    if (line.items) {
      return (
        <Text bold style={{ flexDirection: 'row' }}>
          {line.items.map((item: any, index: number) => (
            <Fragment key={index}>{this.renderLine(item)}</Fragment>
          ))}
        </Text>
      );
    }

    if (line.damage !== undefined) {
      return (
        <Text
          bold
          style={{
            color: line.devastate ? LIGHT_RED : LIGHT_BLUE,
          }}
        >
          {line.damage ? `-${line.damage}` : 0}
        </Text>
      );
    }

    return <Text>{Object.values(line).join(' ')}</Text>;
  }

  render() {
    const { combat } = this.props;

    return (
      <ScrollView style={{ width: '100%' }} nestedScrollEnabled>
        {toJS(combat.logs)
          .reverse()
          .map((log: any, topIndex: number) => {
            const part: any = getLogPart(combat, log, appStore.initData.things, t);
            if (!Array.isArray(part[0])) {
              return (
                <View
                  key={String(log.created) + topIndex}
                  style={{ marginBottom: PADDING1, flexDirection: 'row' }}
                >
                  {part.map((item: any, index: number) => (
                    <View key={index}>{this.renderLine(item)}</View>
                  ))}
                </View>
              );
            }
            return (
              <View key={String(log.created) + topIndex} style={{ marginBottom: PADDING1 }}>
                {part.map((item: any, index: number) => (
                  <View key={index}>
                    {item.map((iitem: any, iindex: number) => (
                      <View key={iindex}>
                        <Text
                          bold
                          numberOfLines={2}
                          {...({ style: { flexDirection: 'row' } } as any)}
                        >
                          {iitem.map((iiitem: any, iiindex: number) => (
                            <Text bold key={iiindex}>
                              {this.renderLine(iiitem)}
                            </Text>
                          ))}
                        </Text>
                      </View>
                    ))}
                  </View>
                ))}
              </View>
            );
          })}
      </ScrollView>
    );
  }
}
